import { devLog } from '../../../../utils/browser';
import { useScroll } from '../../../../utils/useLayout';
import { useQueue } from '../../api/use-queue';
import { getErrorData } from '../../shared/utils/error';
import { SIMULATION_STEPS } from '../simulation-steps';
import { useSimuladorEnergiaSolarState } from '../state';
import { useStatusActions } from './use-status-actions';

export function useSimulationActions({ step }) {
  const status = useStatusActions();
  const { dynamicScrollTo } = useScroll();
  const { token, setProposalId, showErrorStep, setSimulationStep } =
    useSimuladorEnergiaSolarState();

  const handleError = (error, ctx = 'api-create-simulation') => {
    showErrorStep({
      ...getErrorData(error),
      overridePreviousStep: step || null,
      ctx: ctx,
    });
  };

  const queueCreateSimulation = useQueue({
    token,
    enqueueEndpoint: 'energia-solar-queue/v2/simulation/create',
    onError: handleError,
    onComplete: (response) => {
      devLog('Simulação criada com sucesso:', response);

      if (response?.storeNotFound) {
        setSimulationStep(SIMULATION_STEPS.END_JOURNEY_STORE_NOT_FOUND);
        return;
      }

      if (response?.proposalId) {
        setProposalId(response?.proposalId);
        dynamicScrollTo('top');
        status.sendToQueue({});
      }
    },
  });

  return {
    createSimulation: queueCreateSimulation.sendToQueue,
  };
}
